import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  background-color: #ffffff; /* nada de fundo azul aqui */
`

export const LeftSide = styled.div`
  flex: 1.2;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
`

export const RightSide = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
`
export const Card = styled.div`
  width: 100%;
  max-width: 420px;
  margin: 0 24px;
  padding: 32px 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Roboto', system-ui, sans-serif;
  color: #1a1a1a;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
`
export const LeftOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.55),
    rgba(0, 0, 0, 0.15),
    rgba(0, 0, 0, 0)
  );
`

export const LeftTexts = styled.div`
  position: absolute;
  left: 80px;
  bottom: 48px;
  max-width: 420px;
  color: #ffffff;
  font-family: 'Roboto', system-ui, sans-serif;

  h1 {
    font-size: 2.9rem;
    line-height: 1.2;
    font-weight: 700;
    margin: 0 0 12px 0;
  }

  p {
    font-size: 1.2rem;
    opacity: 0.9;
    margin: 0;
  }

  @media (max-width: 1024px) {
    h1 {
      font-size: 2rem;
    }
    p {
      font-size: 0.9rem;
    }
  }

  @media (max-width: 768px) {
    display: none; // se quiser esconder em telas pequenas
  }
`

export const LeftLogoImg = styled.img`
  width: 32px;   /* se ficar pequeno, testa 40 ou 48 */
  height: auto;
  margin-bottom: 24px;
`
